import React from 'react';
import Button from '../ui/Button';

interface EmailStepProps {
    email: string;
    setEmail: (email: string) => void;
    onSendCode: () => Promise<void>;
    isLoading: boolean;
}

const EmailStep: React.FC<EmailStepProps> = ({
                                                 email,
                                                 setEmail,
                                                 onSendCode,
                                                 isLoading,
                                             }) => {
    const handleKeyPress = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            onSendCode();
        }
    };

    return (
        <div id="email-step">
            <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    onKeyPress={handleKeyPress}
                    placeholder="Enter your email address"
                    required
                />
            </div>
            <Button
                onClick={onSendCode}
                loading={isLoading}
                variant="primary"
            >
                Send Login Code
            </Button>
        </div>
    );
};

export default EmailStep;